module.exports = __webpack_public_path__ + "static/media/default-event-cover.49b1b55d.jpg";